import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
interface CTAButtonProps {
  text?: string;
  className?: string;
  href?: string;
  onClick?: () => void;
}
export function CTAButton({
  text = '¡QUIERO LANZAR MI TIENDA EN 48 HORAS!',
  className = '',
  href = 'https://www.lanzadigital360.com/cart/48063055102177:1',
  onClick
}: CTAButtonProps) {
  const isExternal = href.startsWith('http');
  const handleClick = (e: React.MouseEvent) => {
    if (isExternal) {
      trackAddToCart();
    }
    onClick?.(e as any);
  };
  return <motion.a href={href} {...isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} onClick={handleClick} className={`relative group overflow-hidden bg-brandOrange-500 hover:bg-brandOrange-600 text-white font-heading text-xl md:text-2xl py-4 px-8 rounded-lg shadow-[0_0_20px_rgba(249,115,22,0.4)] transition-all flex items-center justify-center gap-3 w-full md:w-auto mx-auto no-underline ${className}`} data-id="element-13">
      <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg opacity-30 bg-gradient-to-b from-transparent via-transparent to-black" data-id="element-14"></span>
      <ShoppingCartIcon className="w-6 h-6 animate-pulse" data-id="element-15" />
      <span className="relative z-10 font-bold tracking-wide" data-id="element-16">{text}</span>
    </motion.a>;
}